import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from '@/types/order';
import Grid, { GridAction, itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import { Modal } from '@/types/modal';
import ModalView from '@/components/modals/Modal';

const View: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('common.remove').toUpperCase(),
      onClick: () => setModal({ kind: 'RemovePickupDeliveryAddress', order, onClose: () => setModal(null) }),
      disabled: !order.isUpdateDeliveryAddressEnabled || !order.pickUpPointName,
    },
  ];

  const items = [
    itemText(t('order.delivery_pickup.pickup_point_name'), order.pickUpPointName),
    itemText(t('order.delivery_pickup.address'), order.pickUpAddress),
    itemText(t('order.delivery_pickup.city'), order.pickUpCity),
    itemText(t('order.delivery_pickup.zip'), order.pickUpZipCode),
  ];

  return (
    <>
      <Container
        title={t('order.delivery_pickup.title')}
        actions={actions}
        testId="delivery_pickup"
      >
        <Grid
          column={5}
          items={items}
        />
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
